import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getClient, getClientCIUs } from '../client.routes';
import { ClientType } from '../types';

export function useGetClient(
  clientId: string | undefined,
  options?: Omit<
    UseQueryOptions<ClientType | null, AxiosError<unknown>, ClientType | null>,
    'queryKey' | 'queryFn'
  >,
) {
  return useQuery({
    queryKey: ['client', clientId],
    queryFn: () => getClient(clientId!),
    enabled: !!clientId,
    ...options,
  });
}

export function useGetCIUsForClient(
  clientUuid: string | undefined,
  includeInactive: boolean = false,
) {
  return useQuery({
    queryKey: ['get-cius-for-client', clientUuid, includeInactive],
    queryFn: () => getClientCIUs(clientUuid!, includeInactive),
    enabled: !!clientUuid,
  });
}
